import React, { useMemo } from 'react';
import { styled } from '@compiled/react';
import { DynamicTableStateless } from '@atlaskit/dynamic-table';
import EmptyState from '@atlaskit/empty-state';
import Pagination from '@atlaskit/pagination';
import { GenericNoResults } from '@atlassian/jira-directory-base/src/assets/index.tsx';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import getTableRows from './body/index.tsx';
import getTableHeader from './header/index.tsx';
import messages from './messages.tsx';
import type { Props } from './types.tsx';
import { getTotalPages, getPageLabels } from './utils.tsx';

const ProjectsTable = (props: Props) => {
	const {
		intl,
		page,
		limit,
		isLoading,
		onPageChange,
		data,
		onSort,
		sortKey,
		sortOrder,
		status,
		refetchProjects,
	} = props;
	const paginationi18n = useMemo(
		() => ({
			prev: intl.formatMessage(messages.paginationPrev),
			next: intl.formatMessage(messages.paginationNext),
		}),
		[intl],
	);
	const totalPages = getTotalPages(data, limit);

	return (
		<>
			<DynamicTableStateless
				testId="inactive-projects-directory-base.ui.projects-table.dynamic-table-stateless"
				head={getTableHeader(intl, status)}
				rows={getTableRows(data, status, refetchProjects)}
				isLoading={isLoading}
				// @ts-expect-error - TS2741 - Property 'label' is missing in type '{ prev: string; next: string; }' but required in type 'I18nShape'.
				paginationi18n={paginationi18n}
				onSort={onSort}
				sortKey={sortKey}
				sortOrder={sortOrder}
				emptyView={
					<EmptyState imageUrl={GenericNoResults} header={intl.formatMessage(messages.noData)} />
				}
				isFixedSize
			/>
			{totalPages > 1 ? (
				<PaginationWrapper>
					<Pagination
						selectedIndex={page - 1}
						pages={getPageLabels(totalPages)}
						onChange={onPageChange}
					/>
				</PaginationWrapper>
			) : null}
		</>
	);
};

export default injectIntl(ProjectsTable);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const PaginationWrapper = styled.div({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
});
